import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface Department {
  code: string
  name: string
  costCenterId: string
  managementId: string
}

export async function getVacationAccumulationRequests(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['vacation_accumulation_requests.payroll_id=:payrollId']
  if (search) {
    where.push(
      `CONCAT(employees.name,vacation_policies.code,process_status.name) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = ['order by vacation_accumulation_requests.created_at desc'])
  // result
  const response: any = await getData({
    tables: ['pg_vacation_accumulation_requests'],
    fields: [
      'employees.name as employeeName',
      'vacation_policies.code as policyCode',
      'process_status.name as status',
      'process_status.code as statusCode',
      'vacation_accumulation_requests.result',
      'vacation_accumulation_requests.created_at'
    ],
    join: [
      'LEFT JOIN employees ON vacation_accumulation_requests.employee_id=employees.id',
      'LEFT JOIN vacation_policies ON vacation_accumulation_requests.vacation_policy_id=vacation_policies.id',
      'LEFT JOIN process_status ON vacation_accumulation_requests.status_id=process_status.id'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}
